import { DiaryMark } from '@app/components/icons/ui-icons';
import Closing from '@app/components/sections/closing';
import DiaryTeaser from '@app/components/sections/diary-teaser';
import Opening from '@app/components/sections/opening';
import Story from '@app/components/sections/story';
import Testimonial from '@app/components/sections/testimonial';
import Work from '@app/components/sections/work';
import { diary, profile, projects, stack, testimonials, timeline } from '@app/content';
import Layout from '@app/layouts/_layout';
import Link from 'next/link';

export default function Home() {
    return (
        <Layout
            profile={profile}
            topRight={
                <Link href="/diary" className="t-label group inline-flex items-center gap-2 text-ink transition-colors hover:text-accent">
                    <DiaryMark className="text-muted transition-colors group-hover:text-accent" />
                    Diary
                </Link>
            }
        >
            <Opening profile={profile} />
            <Story entries={timeline} />
            <Work projects={projects} />

            <DiaryTeaser entries={diary} />

            <Testimonial testimonials={testimonials} />
            <Closing profile={profile} stack={stack} />
        </Layout>
    );
}
